import "@/App.css";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import LogoBar from "./components/LogoBar";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import ProductSection from "./components/ProductSection";
import FeaturesSection from "./components/FeaturesSection";
import StatsSection from "./components/StatsSection";
import HowItWorksSection from "./components/HowItWorksSection";
import AdvantageSection from "./components/AdvantageSection";
import TractionSection from "./components/TractionSection";
import AudienceSection from "./components/AudienceSection";
import FounderSection from "./components/FounderSection";
import DemoSection from "./components/DemoSection";
import DocsSection from "./components/DocsSection";
import SandboxSection from "./components/SandboxSection";
import Footer from "./components/Footer";
import StickyCtaBar from "./components/StickyCtaBar";
import VideoPopup from "./components/VideoPopup";

function App() {
  return (
    <div className="bg-black text-white min-h-screen overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <LogoBar />
      <ProblemSection />
      <SolutionSection />
      <ProductSection />
      <FeaturesSection />
      <StatsSection />
      <HowItWorksSection />
      <AdvantageSection />
      <TractionSection />
      <AudienceSection />
      <FounderSection />
      <DemoSection />
      <DocsSection />
      <SandboxSection />
      <Footer />
      <StickyCtaBar />
      <VideoPopup />
    </div>
  );
}

export default App;
